import { PromoMobile, PromoNewHome, PromoSmartMap } from '@zoopla/assets';

export const internalPromoIds = ['mobile', 'smartmap', 'newhomes'] as const;

export type InternalPromoId = typeof internalPromoIds[number];

export type InternalPromoData = {
    name: string;
    title: string;
    details: string;
    cta: string;
    image: {
        src: string;
        alt: string;
    };
    link: string;
};

export const internalPromos: Record<InternalPromoId, InternalPromoData> = {
    mobile: {
        name: 'mobile',
        title: 'Zoopla app',
        details: 'Download our free mobile apps for property info on the go',
        cta: 'Download the app',
        image: {
            src: PromoMobile,
            alt: 'Zoopla mobile app'
        },
        link: 'mobile/'
    },
    smartmap: {
        name: 'smartmap',
        title: 'Draw your search',
        details: 'Pinpoint exactly where to live by using our SmartMaps search',
        cta: 'Draw your search',
        image: {
            src: PromoSmartMap,
            alt: 'Example drawing on map'
        },
        link: 'map'
    },
    newhomes: {
        name: 'newhomes',
        title: 'New Homes',
        details: 'Find new homes from thousands of UK developments',
        cta: 'Search new homes',
        image: {
            src: PromoNewHome,
            alt: 'A new home'
        },
        link: 'new-homes'
    }
} as const;
